module.exports = [{"url":"nelly-toncheva","name":"Нели Тончева","position":"Директор Продажби и член на УС","email":"nelly.toncheva@alcomet.eu","phone":"+35954858615","foreignLanguages":"English","img":"/static/img/contacts/sales_department/nely-toncheva.jpg"}]


//////////////////
// WEBPACK FOOTER
// ./src/components/contacts/MainSalesDepartment.json
// module id = 98Or
// module chunks = 1